import React from 'react';
import Item from './Item';

export default ({items, selected, onClick}) => (
	<div id="sidebar">
        {items.reverse().map((item, i, array) => {
            let id = (array.size - 1) - i
            return (
                <Item 
                    key={id}
                    id={id}
                    name={item.get('title')} 
                    selected={id === selected}
                    onClick={onClick}
                />
            )
        })}
	</div>
)



// WEBPACK FOOTER //
// ./src/components/Sidebar.js